export const DETECTION_ACTIONS = {
  REDACT: "REDACT",
  NOTIFY: "NOTIFY",
  MARK_RESOLVED: "MARK_RESOLVED",
  MARK_FALSE_POSITIVE: "MARK_FALSE_POSITIVE",
  CANCEL: "CANCEL_DELAYED_ACTION",
};
